import PageTitle from 'Components/GlobalComponents/PageTitle.vue';
const GlobalComponents = {
   install(Vue){
      Vue.component('PageTitle', PageTitle)
   }
}
export default GlobalComponents